export default __webpack_public_path__ + "static/hero-banner-generic-en-c0185cffe75f5fa03bb687fae930f81c.jpeg";